const round = (value, fixed) => +value.toFixed(fixed);

module.exports = {
    round
};
